import * as $ajax from './_ajax'
import * as $msg from './_msg'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    accountId: string
}

var options: IInitOptions

export function init($options: any): void {
    options = $options

    elem('save').click(function () {
        $ajax.post({
            loadingText: 'Sparar...',
            url: '/Account/AccountEditSave',
            data: {
                id: options.accountId,
                firstname: elem('Ial67Eq42lwJ').val(),
                lastname: elem('e2ASmksciJNM').val(),
                organization: elem('organization').val(),
                department: elem('department').val(),
                parentaccount: elem('parentaccount').val(),
                email: elem('RrjbuflT19FC').val(),
                phone: elem('ph2GiRd5wyyz').val(),
                password1: elem('password1').val(),
                password2: elem('password2').val(),
                childaccountscount: elem('childaccountscount').val(),
                childaccountsdomain: elem('childaccountsdomain').val(),
                regions: (elem('regions').val() || []).join(','),
                services: (elem('services').val() || []).join(','),
            },
            success: function (res) {
                if (res.Ok) {
                    location.href = '/Account/AccountsList'
                } else {
                    $msg.showError(res.Message)
                }
            },
        })
    })
}

function elem(suffix: string): JQuery {
    return $('.' + options.pagePrefix + '__' + suffix)
}
